function Home (props: any) {
    return(
        <h4 className="display-4 text-center">Welcome to the Driver Test Check-In system!</h4>
    );
}

export default Home;